export default __webpack_public_path__ + "static/media/DATA.69b6e519.webp";